module.exports = __webpack_public_path__ + "img/18_110.b707a5c0.png";